var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9766 0.812991C23.3561 1.21431 23.3383 1.84722 22.937 2.22665L9.18701 15.2266C8.78849 15.6034 8.16085 15.5889 7.78016 15.1941L1.03016 8.19414C0.646796 7.79658 0.658306 7.16352 1.05587 6.78016C1.45342 6.3968 2.08648 6.40831 2.46985 6.80587L8.53251 13.0931L21.563 0.773356C21.9643 0.39393 22.5972 0.411675 22.9766 0.812991Z",
    fill: "#4b4b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.83140c0450ee3b6d39387a214135e45c.svg";
export { ForwardRef as ReactComponent };